import qs from 'qs'
import React, { useEffect, useState } from 'react'
import { Tab } from 'react-bootstrap'
import { post } from 'superagent/lib/client'
import Content from '../../components/common/layout/Content'
import ContentTabs from '../../components/contenttabs/ContentTabs'
import { setQueryStringWithoutPageReload } from '../../components/helpers/FormatLinks'
import UnclaimedPacksList from '../../components/packs/UnclaimedPacksList'
import Page from '../../components/page/Page'
import SearchComponent from '../../components/searchitems'
import TabItem from '../../components/tabitem/TabItem'
import { useSharedState } from '../../components/waxplorer/Waxplorer'
import config from '../../config.json'

const UnpackPage = (props) => {
    const [state, dispatch] = useSharedState()
    let values =
        typeof window !== 'undefined'
            ? qs.parse(
                  window.location.search.substring(
                      1,
                      window.location.search.length,
                  ),
              )
            : []

    const [isLoading, setIsLoading] = useState(false)
    const unpacked = state.unpacked

    const keys = ['mypacks', 'unclaimed']

    const activeUser = state?.activeUser?.accountName
    const loggedOut = activeUser === null

    const [assetIds, setAssetIds] = useState(null)

    const [tabKey, setTabKey] = useState(
        typeof window !== 'undefined'
            ? values['tab'] && keys.includes(values['tab'])
                ? values['tab']
                : 'mypacks'
            : props.tab && keys.includes(props.tab)
            ? props.tab
            : 'mypacks',
    )

    const initTabs = async (key, user, loggedOut, initial = false) => {
        if (key !== tabKey || initial) {
            const query = values

            delete query['order_dir']
            delete query['search_type']
            delete query['order_by']
            query['tab'] = key
            if (user) query['user'] = user
            else delete query['user']
            delete query['offer_type']

            if (!initial) setQueryStringWithoutPageReload(qs.stringify(query))
            setTabKey(key)
        }
    }

    const getUnclaimedPacks = async (user) => {
        const promises = []
        {
            const body = {
                json: true,
                code: 'atomicpacksx',
                scope: 'atomicpacksx',
                table: 'unboxpacks',
                table_key: 'unboxer',
                lower_bound: user,
                upper_bound: user,
                index_position: 2,
                key_type: 'name',
                limit: 200,
                reverse: false,
                show_payer: false,
            }

            const url =
                process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                    ? config.testapi + '/v1/chain/get_table_rows'
                    : state.api + '/v1/chain/get_table_rows'
            promises.push(post(url, body))
        }
        {
            const body = {
                json: true,
                code: 'nfthivepacks',
                scope: 'nfthivepacks',
                table: 'unpackpacks',
                table_key: 'owner',
                lower_bound: user,
                upper_bound: user,
                index_position: 2,
                key_type: 'name',
                limit: 200,
                reverse: false,
                show_payer: false,
            }

            const url =
                process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                    ? config.testapi + '/v1/chain/get_table_rows'
                    : state.api + '/v1/chain/get_table_rows'
            promises.push(post(url, body))
        }
        {
            const body = {
                json: true,
                code: 'neftyblocksp',
                scope: 'neftyblocksp',
                table: 'claimassets',
                table_key: 'recipient',
                lower_bound: user,
                upper_bound: user,
                index_position: 2,
                key_type: 'name',
                limit: 200,
                reverse: false,
                show_payer: false,
            }

            const url =
                process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
                    ? config.testapi + '/v1/chain/get_table_rows'
                    : state.api + '/v1/chain/get_table_rows'
            promises.push(post(url, body))
        }

        if (promises.length > 0) {
            Promise.all(promises).then((res) => getUnclaimedPacksResult(res))
        }
    }

    const getUnclaimedPacksResult = (results) => {
        const asset_ids = []

        let unboxer = null

        results.map((res) => {
            if (res && res.status === 200 && res.body && res.body.rows) {
                res.body.rows.map((row) => {
                    if (!unboxer) {
                        unboxer = row.unboxer
                            ? row.unboxer
                            : row.recipient
                            ? row.recipient
                            : row.owner
                    }
                    asset_ids.push(
                        row.pack_asset_id ? row.pack_asset_id : row.claim_id,
                    )
                })
            }
        })

        setAssetIds(asset_ids)
    }

    const initPacks = (user) => {
        setIsLoading(true)
        getUnclaimedPacks(user)
    }

    useEffect(() => {
        initTabs(tabKey, activeUser, loggedOut, true)
        if (activeUser) initPacks(activeUser)
        if (unpacked) dispatch({ type: 'SET_UNPACKED', payload: false })
    }, [tabKey, activeUser, loggedOut])

    const login = () => {}

    return (
        <Page
            id={'UnpackPage'}
            title={config.titles.unpack}
            description={config.descriptions.unpack}
            {...props}
        >
            <Content headline="Packs">
                <div className="w-full mx-auto">
                    {loggedOut ? (
                        <div onClick={login}>Login</div>
                    ) : (
                        <ContentTabs
                            tabKey={tabKey}
                            onSelect={(k) => initTabs(k)}
                            justify={'justify-evenly'}
                        >
                            <Tab
                                eventKey="mypacks"
                                title={
                                    <TabItem
                                        target={'mypacks'}
                                        tabKey={tabKey}
                                        title={'My Packs'}
                                    />
                                }
                            >
                                {tabKey === 'mypacks' && (
                                    <SearchComponent
                                        {...props}
                                        searchSettings={{
                                            search_type: {
                                                value: 'my_packs',
                                                fixed: true,
                                            },
                                            order_by: {
                                                value: 'date_desc',
                                                fixed: false,
                                            },
                                            owner: {
                                                value: activeUser,
                                                fixed: true,
                                            },
                                            minimal: false,
                                            tab: 'mypacks',
                                            page_component: false,
                                            limit: {
                                                value: 60,
                                                fixed: true,
                                            },
                                            expanded: false,
                                        }}
                                        limit={60}
                                        tab={'mypacks'}
                                    />
                                )}
                            </Tab>
                            <Tab
                                eventKey="unclaimed"
                                title={
                                    <TabItem
                                        user={activeUser}
                                        target={'unclaimed'}
                                        tabKey={tabKey}
                                        title={'Unclaimed Packs'}
                                    />
                                }
                            >
                                {tabKey === 'unclaimed' && (
                                    <UnclaimedPacksList
                                        user={activeUser}
                                        {...props}
                                        assetIds={assetIds}
                                        isLoading={isLoading}
                                        setIsLoading={setIsLoading}
                                        unpacked={unpacked}
                                    />
                                )}
                            </Tab>
                        </ContentTabs>
                    )}
                </div>
            </Content>
        </Page>
    )
}

UnpackPage.getInitialProps = async (ctx) => {
    const paths = ctx.asPath.split('/')

    return qs.parse(paths[paths.length - 1].replace('?', ''))
}

export default UnpackPage
